import React from 'react';
import { UserHeader } from 'shared/ui/user-header/user-header';
import { BusinessApi } from 'shared/api';
import { UserRoleEnum, userStore } from 'entities/index';

interface IAdministratorHeaderProps {
  administratorId: string;
  dataFio: string;
  dataEmail: string;
  dataPhone: string;
  dataImgUrl: string;
}
export const AdministratorHeader: React.FC<IAdministratorHeaderProps> = ({
  administratorId,
  dataFio,
  dataPhone,
  dataImgUrl,
  dataEmail,
}) => {
  const handleDelete = async () => {
    if (administratorId) {
      await BusinessApi.deleteAdministrator({ administratorId });
    }
  };

  const deleteButton =
    userStore.role === UserRoleEnum.OWNER
      ? { text: 'Удалить управляющего', onClick: handleDelete }
      : undefined;

  return (
    <UserHeader
      fio={dataFio}
      phone={dataPhone}
      email={dataEmail}
      imgUrl={dataImgUrl}
      onSaveImage={(url: string) =>
        BusinessApi.updateAdministratorInfo({
          adminId: administratorId,
          imgUrl: url,
        })
      }
      deleteButton={deleteButton}
      successMessage={deleteButton ? 'Управляющий успешно удален' : undefined}
    />
  );
};
